import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'listToString' })
export class ListToStringPipe implements PipeTransform {
  transform<T>(value: T[], field?: keyof T, separator: string = ', '): string {
    if (!value || value.length === 0) {
      return '';
    }

    if (field) {
      return value.map((item) => String(item[field])).join(separator);
    } else {
      return value.map((item) => String(item)).join(separator);
    }
  }
}
